import { call, put, takeLatest } from "redux-saga/effects";
import { axiosInstance } from "../../network/apis";
import { GET_REWADRS_HISTORY_URL, GET_SUBORDINATES_SPOT_REWARD, GET_VIEWEDUSER_DATA_SPOT_FREWARD, POST_SPOT_REWARD_COINS } from "../../network/apis/apiPath";
import { HISTORY_REWARDS_DATA, SEND_REWARD_COINS, SPOT_REWARD_AVAILABLE_COINS, SUBORDINATE_SPOT_REWARD } from "../type";
import { saveRewardsHistoryDataConfig, saveSpotRewardAvailableCoinsConfig, saveSpotRewardConfig, } from "./spotRewardConfigSlice";
import CustomMessage from "../../components/common/Snackbar/Snackbar";
import { CONFIRMATION_REWARD_PATH } from "../../utils/Constants";


function* subordinateSpotRewardConfigWorker(action) {
    const { setLoader } = action;
    try {
        const response = (yield call(axiosInstance.get, GET_SUBORDINATES_SPOT_REWARD))
        if (response && response.data) {
            const EmployeeCode = localStorage.getItem("EmployeeCode");
            const subordinatesDatas = response.data.subordinatesList && response.data.subordinatesList.length ? response.data.subordinatesList.filter((empcode) => empcode.code !== EmployeeCode) : []
            yield put(saveSpotRewardConfig(subordinatesDatas));
            setLoader(false)
        }
    } catch (error) {
        console.log(error);
        setLoader(false)
    }
}

function* spotRewardCoinsAvailableConfigWorker(action) {
    const { payload, setLoading } = action;
    const { managerCode } = payload;
    try {
        const response = (yield call(axiosInstance.get, `${GET_VIEWEDUSER_DATA_SPOT_FREWARD}/${managerCode}`))
        if (response.data) {
            yield put(saveSpotRewardAvailableCoinsConfig(response.data));
            setLoading(false)
        }
    } catch (error) {
        console.log(error);
        setLoading(false)
    }
}

function* spotRewardSendCoinsConfigWorker(action) {
    const { payload, navigate, userViewedData, rewardCoins, enqueueSnackbar, setOpen, setLoader } = action
    try {
        const response = (yield call(axiosInstance.post, POST_SPOT_REWARD_COINS, payload));
        if (response) {
            setLoader(false)
            navigate(CONFIRMATION_REWARD_PATH, { state: { userViewedData: userViewedData, rewardCoins: rewardCoins } })
        }

    } catch (error) {
        setLoader(false)
        CustomMessage(error?.response?.data?.message, "error", enqueueSnackbar);
        setOpen(false)
        console.log(error);
    }
}

function* rewardsHistoryConfigWorker(action) {
    const { payload, setLoader } = action;
    const { managerCode } = payload;
    try {
        const response = (yield call(axiosInstance.get, `${GET_REWADRS_HISTORY_URL}?managerCode=${managerCode}&pageNumber=0&pageSize=10`,));
        if (response) {
            yield put(saveRewardsHistoryDataConfig(response?.data?.entities))
            setLoader(false)
        }
    } catch (error) {
        console.log(error);
        setLoader(false)
    }
}


export function* spotRewardConfigWatcher() {
    yield takeLatest(SUBORDINATE_SPOT_REWARD, subordinateSpotRewardConfigWorker);
    yield takeLatest(SPOT_REWARD_AVAILABLE_COINS, spotRewardCoinsAvailableConfigWorker);
    yield takeLatest(SEND_REWARD_COINS, spotRewardSendCoinsConfigWorker);
    yield takeLatest(HISTORY_REWARDS_DATA, rewardsHistoryConfigWorker)
};